import React, {Component, ErrorInfo} from 'react'
import {Button} from '~/src/design-system/Primitives'
import {reportError} from '../../../utils/errorReporter'

interface Props {
  children: React.ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class AppErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {hasError: false}
  }

  static getDerivedStateFromError(error: Error): State {
    return {hasError: true, error}
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Unhandled application error:', error, errorInfo)
    reportError('ErrorBoundary', error.message, error.stack)
  }

  handleReload = (): void => {
    window.location.reload()
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            gap: 'var(--space-4)',
            padding: 'var(--space-6)',
          }}>
          <h4
            style={{
              fontSize: 'var(--fs-subtitle)',
              fontWeight: 'var(--fw-semibold)',
              color: 'var(--danger)',
              margin: 0,
            }}>
            Something went wrong
          </h4>
          <p
            style={{
              fontSize: 'var(--fs-body)',
              color: 'var(--neutral-600)',
              textAlign: 'center',
              maxWidth: 500,
              margin: 0,
            }}>
            An unexpected error occurred. Please try reloading the page. If the problem persists,
            contact support.
          </p>
          <Button
            variant="primary"
            onClick={this.handleReload}
            style={{marginTop: 'var(--space-4)'}}>
            Reload Page
          </Button>
        </div>
      )
    }

    return this.props.children
  }
}
